import { createContext } from "react";

export const ContentDetailsModalContext = createContext();
